import { colors } from 'styles';
import backgroundSVG from 'assets/bgtexture.svg';

import { SurveySubTypes } from './constants';

const standardTheme = {
  backgroundColor: colors.blue.base,
  backgroundImage: `url(${backgroundSVG})`,
  chooseOne: {
    otherOptionButton: {
      background: colors.yellow.base,
      color: colors.blue.base,
      focusColor: colors.blue.light,
    },
    selectedColor: colors.green.base,
  },
  linkColor: colors.yellow.base,
  matrix: {
    background: 'rgba(255, 255, 255, 0.2)',
    hoverBackground: 'rgba(255, 255, 255, 0.25)',
  },
  message: {
    headingColor: colors.white,
    standard: {
      align: 'center',
      fontSize: {
        base: '2.2rem',
        desktop: '2.8rem',
        tablet: '2.4rem',
      },
    },
  },
  radioButton: {
    borderColor: colors.white,
    focus: {
      shadow: colors.yellow.base,
    },
    selected: {
      background: colors.white,
      borderColor: colors.white,
    },
    unselected: {
      background: colors.blue.base,
      borderColor: colors.white,
    },
  },
  ratingItem: {
    checked: {
      background: colors.white,
      color: colors.sierra.base,
    },
    focus: {
      background: 'rgba(255, 255, 255, 0.3)',
      shadow: colors.yellow.base,
    },
    hover: {
      background: 'rgba(255, 255, 255, 0.3)',
    },
    unchecked: {
      background: 'rgba(255, 255, 255, 0.2)',
      color: colors.white,
    },
  },
  surveyItem: {
    marginBottom: '250px',
  },
};

const darkTheme = {
  ...standardTheme,
  backgroundColor: colors.sierra.base,
  chooseOne: {
    ...standardTheme.chooseOne,
    otherOptionButton: {
      ...standardTheme.chooseOne.otherOptionButton,
      background: colors.brandedBlue.base,
      color: colors.white,
      focusColor: colors.yellow.base,
    },
    selectedColor: colors.brandedBlue.base,
  },
  matrix: {
    ...standardTheme.matrix,
    background: 'rgba(69, 120, 151, 0.4)',
    hoverBackground: 'rgba(69, 120, 151, 0.6)',
  },
  message: {
    ...standardTheme.message,
    headingColor: colors.yellow.base,
  },
  radioButton: {
    ...standardTheme.radioButton,
    unselected: {
      ...standardTheme.radioButton.unselected,
      background: colors.sierra.base,
    },
  },
  ratingItem: {
    ...standardTheme.ratingItem,
    checked: {
      background: colors.brandedBlue.dark,
      color: colors.white,
    },
    focus: {
      ...standardTheme.ratingItem.focus,
      shadow: colors.white,
    },
  },
};

const ccaDemographicSurveyTheme = {
  ...standardTheme,
  backgroundColor: colors.brandedGreen.base,
  chooseOne: {
    ...standardTheme.chooseOne,
    otherOptionButton: {
      ...standardTheme.chooseOne.otherOptionButton,
      color: colors.brandedGreen.light,
    },
  },
  message: {
    ...standardTheme.message,
    headingColor: colors.yellow.base,
  },
  radioButton: {
    ...standardTheme.radioButton,
    unselected: {
      ...standardTheme.radioButton.unselected,
      background: colors.brandedGreen.base,
    },
  },
};

const familiaritySurveyTheme = {
  ...darkTheme,
  message: {
    ...darkTheme.message,
    headingColor: colors.brandedTeal.base,
    standard: {
      ...darkTheme.message.standard,
      align: 'left',
      fontSize: {
        base: '1.8rem',
        desktop: '2.2rem',
        tablet: '2rem',
      },
    },
  },
  surveyItem: {
    ...darkTheme.surveyItem,
    marginBottom: '325px',
  },
};

const vignetteAssessmentTheme = {
  ...darkTheme,
  backgroundImage: 'none',
  message: {
    ...darkTheme.message,
    headingColor: colors.white,
    standard: {
      ...darkTheme.message.standard,
      fontSize: {
        base: '2rem',
        desktop: '2.4rem',
        tablet: '2.2rem',
      },
    },
  },
};

export const getTheme = surveySubType => {
  switch (surveySubType) {
    case SurveySubTypes.CCADemographic:
      return ccaDemographicSurveyTheme;
    case SurveySubTypes.Familiarity:
      return familiaritySurveyTheme;
    case SurveySubTypes.Vignette:
      return vignetteAssessmentTheme;
    case SurveySubTypes.Standard:
    default:
      return standardTheme;
  }
};
